module.exports = __webpack_public_path__ + "static/media/social-wechat.51696ab6.svg";